<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>Firstly, I want to thank Almighty Allah for everything. We can never thank Allah enough for the continuous grace, mercy and guidance that fill our lives. Then I want to thank all my teachers and professors in all the stages of my life who always encouraged me.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?e613c868